import {
  KoobSearchBar,
  KoobBadge,
  KoobButton,
  KoobInputSegmented,
  KoobSegmentedControl,
  KoobSegmentedControlItem,
} from '@koob/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PromotionKindEnum } from 'utils';

// Type filters that don't apply to experiences (hotel-only benefit kinds).
export const EXPERIENCE_HIDDEN_TYPE_FILTERS = [
  PromotionKindEnum.FREE_NIGHT,
  PromotionKindEnum.AMENITY,
  PromotionKindEnum.UPGRADE_ROOM,
];

export default function PromotionsFilterBar({
  activeTab,
  searchQuery,
  setSearchQuery,
  typeFilter,
  setTypeFilter,
  selectionFilter,
  setSelectionFilter,
  onSelectAll,
  onDeselectAll,
  selectedCount,
  totalCount,
  isLoading,
}) {
  const { t } = useTranslation('toConnectionRequest');

  const typeOptions = [
    { label: t('misc:all'), value: null },
    {
      label: t('promotionForm:promotionTypes.amount'),
      value: PromotionKindEnum.AMOUNT,
    },
    {
      label: t('promotionForm:promotionTypes.percent'),
      value: PromotionKindEnum.PERCENT,
    },
    {
      label: t('promotionForm:promotionTypes.supplement'),
      value: PromotionKindEnum.SUPPLEMENT,
    },
    {
      label: t('promotionForm:promotionTypes.supplement_percent'),
      value: PromotionKindEnum.SUPPLEMENT_PERCENT,
    },
    {
      label: t('promotionForm:promotionTypes.free_night'),
      value: PromotionKindEnum.FREE_NIGHT,
    },
    {
      label: t('promotionForm:promotionTypes.amenities'),
      value: PromotionKindEnum.AMENITY,
    },
    {
      label: t('promotionForm:promotionTypes.upgrade_room'),
      value: PromotionKindEnum.UPGRADE_ROOM,
    },
  ].filter(
    (option) =>
      activeTab !== 'experience' ||
      !EXPERIENCE_HIDDEN_TYPE_FILTERS.includes(option.value),
  );

  return (
    <div className="flex flex-col space-y-3">
      <div>
        <h3 className="text-base font-semibold text-gray-800 mb-2">
          {t('promotions.search.title')}
        </h3>
        <div className="grid grid-cols-2 gap-3">
          <KoobSearchBar
            value={searchQuery}
            onChange={setSearchQuery}
            placeholder={t('promotions.search.placeholder')}
          />
        </div>
      </div>

      {/* Filter Pills */}
      <KoobInputSegmented
        options={typeOptions}
        value={typeFilter}
        onChange={(value) => setTypeFilter(value)}
      />

      {/* List Header / Actions Bar */}
      <div className="pt-5 flex space-x-3 items-center">
        <KoobButton variant="primary" size="sm" onClick={onSelectAll}>
          {t('bulkEdit.requestSelector.selectAll')}
        </KoobButton>
        <KoobButton variant="primary" size="sm" onClick={onDeselectAll}>
          {t('bulkEdit.requestSelector.deselectAll')}
        </KoobButton>

        <KoobBadge color="gray" shape="square">
          {/* While loading, blank the selected count but keep the badge size. */}
          {t('bulkEdit.requestSelector.selectedCount', {
            count: isLoading ? '' : selectedCount,
            total: isLoading ? '' : totalCount,
          })}
        </KoobBadge>

        <KoobSegmentedControl
          size="sm"
          value={selectionFilter}
          onValueChange={setSelectionFilter}
        >
          <KoobSegmentedControlItem value="all">
            {t('bulkEdit.editor.filters.all')}
          </KoobSegmentedControlItem>
          <KoobSegmentedControlItem value="selected">
            {t('bulkEdit.editor.filters.selected')}
          </KoobSegmentedControlItem>
          <KoobSegmentedControlItem value="unselected">
            {t('bulkEdit.editor.filters.notSelected')}
          </KoobSegmentedControlItem>
        </KoobSegmentedControl>
      </div>
    </div>
  );
}
